var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLinkIcon({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 15,
    viewBox: "0 0 16 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.65798 9.47046C0.139002 9.65936 -0.128585 10.2332 0.0603074 10.7522C0.2492 11.2712 0.823042 11.5387 1.34202 11.3498L0.65798 9.47046ZM15.1487 6.01293C15.3821 5.51239 15.1656 4.91741 14.665 4.68401L6.50826 0.880442C6.00772 0.647037 5.41274 0.863592 5.17933 1.36413C4.94592 1.86467 5.16248 2.45965 5.66302 2.69306L12.9135 6.074L9.53254 13.3245C9.29913 13.825 9.51569 14.42 10.0162 14.6534C10.5168 14.8868 11.1117 14.6702 11.3452 14.1697L15.1487 6.01293ZM1.34202 11.3498L14.5844 6.53001L13.9004 4.65062L0.65798 9.47046L1.34202 11.3498Z",
    fill: "#5627D9"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLinkIcon);
export default __webpack_public_path__ + "static/media/link-icon.1400e577568915112978237a6f6f9818.svg";
export { ForwardRef as ReactComponent };